/**
 * Caminhos dos assets de marca DTS. Os arquivos ficam em `apps/web/public/brand/`
 * e são servidos pela raiz (`/brand/...`) — trocar a arte é só substituir o
 * arquivo, sem rebuild de import. Enquanto um arquivo não existir, os
 * consumidores (`BrandLogo`, tela de login) degradam graciosamente.
 */
export const BRAND = {
  /** Logo horizontal DTS (header da área logada + card de login). */
  logo: '/brand/dts-logo.png',
  /** Foto de destaque no painel lateral do login (desktop). */
  loginHero: '/brand/login-hero.jpg',
} as const;
